import { useEffect, useRef } from 'react';
export var useFirstRender = function useFirstRender() {
  var firstRender = useRef(true);
  useEffect(function () {
    firstRender.current = false;
  }, []);
  return firstRender;
};